import {
  FormBiography,
  FormResetPassword,
  FormUpdatePassword,
} from "@components/resolvers/school.resolvers";
import { BaseService } from "./base.service";
import {
  StudentAbsencesResponse,
  StudentAchievementResponse,
  StudentBiographyResponse,
  StudentBioResponse,
  studentDailyScoresResponse,
  studentFinalScoresResponse,
  StudentHealthResponse,
  studentSulukResponse,
  StudentTafaquhResponse,
  StudentTahfidzResponse,
  StudentViolationsResponse,
} from "./dtos/school.dto";
import axios from "axios";
import { BaseResponse, BaseResponseExternal } from "./dtos/base.dto";

interface SchoolServiceInterface {
  queries: {
    GET_SCHOOL_STUDENT_BIO: string;
    GET_SCHOOL_STUDENT_BIOGRAPHY: string;
    GET_SCHOOL_STUDENT_HEALTH: string;
    GET_SCHOOL_STUDENT_ABSENCES: string;
    GET_SCHOOL_STUDENT_ACHIEVEMENT: string;
    GET_SCHOOL_STUDENT_VIOLATIONS: string;
    GET_SCHOOL_STUDENT_TAHFIDZ: string;
    GET_SCHOOL_STUDENT_DAILY_SCORES: string;
    GET_SCHOOL_STUDENT_FINAL_SCORES: string;
    GET_SCHOOL_STUDENT_SULUK: string;
    GET_SCHOOL_STUDENT_RAPOR: string;
    GET_SCHOOL_STUDENT_TAFAQUH: string;
  };
  studentBio(): Promise<StudentBioResponse>;
  studentBiography(nis: string): Promise<StudentBiographyResponse>;
  updateStudentBiography(
    payload: FormBiography,
  ): Promise<StudentBiographyResponse>;
  studentHealth(payload: {
    nis: string;
    limit: string;
  }): Promise<StudentHealthResponse>;
  studentAbsences(limit: string): Promise<StudentAbsencesResponse>;
  studentAchievement(payload: {
    nis: string;
    limit: string;
  }): Promise<StudentAchievementResponse>;
  studentViolations(payload: {
    nis: string;
    limit: string;
  }): Promise<StudentViolationsResponse>;
  studentTahfidz(payload: {
    nis: string;
    limit: string;
  }): Promise<StudentTahfidzResponse>;
  studentDailyScores(payload: {
    nis: string;
    semester: string;
  }): Promise<studentDailyScoresResponse>;

  studentFinalScores(payload: {
    nis: string;
    semester: string;
    type: string;
  }): Promise<studentFinalScoresResponse>;

  studentSuluk(payload: { nis: string }): Promise<studentSulukResponse>;
  studentRapor(payload: {
    nis: string;
    semester: string;
  }): Promise<BaseResponse>;

  studentTafaquh(payload: {
    nis: string;
    limit: string;
  }): Promise<StudentTafaquhResponse>;

  checkPassword(payload: FormResetPassword): Promise<BaseResponseExternal>;
  updatePassword(payload: FormUpdatePassword): Promise<BaseResponseExternal>;
}
export const SchoolService: SchoolServiceInterface = {
  queries: {
    GET_SCHOOL_STUDENT_BIO: "GET_SCHOOL_STUDENT_BIO",
    GET_SCHOOL_STUDENT_BIOGRAPHY: "GET_SCHOOL_STUDENT_BIOGRAPHY",
    GET_SCHOOL_STUDENT_HEALTH: "GET_SCHOOL_STUDENT_HEALTH",
    GET_SCHOOL_STUDENT_ABSENCES: "GET_SCHOOL_STUDENT_ABSENCES",
    GET_SCHOOL_STUDENT_ACHIEVEMENT: "GET_SCHOOL_STUDENT_ACHIEVEMENT",
    GET_SCHOOL_STUDENT_VIOLATIONS: "GET_SCHOOL_STUDENT_VIOLATIONS",
    GET_SCHOOL_STUDENT_TAHFIDZ: "GET_SCHOOL_STUDENT_TAHFIDZ",
    GET_SCHOOL_STUDENT_DAILY_SCORES: "GET_SCHOOL_STUDENT_DAILY_SCORES",
    GET_SCHOOL_STUDENT_FINAL_SCORES: "GET_SCHOOL_STUDENT_FINAL_SCORES",
    GET_SCHOOL_STUDENT_SULUK: "GET_SCHOOL_STUDENT_SULUK",
    GET_SCHOOL_STUDENT_RAPOR: "GET_SCHOOL_STUDENT_RAPOR",
    GET_SCHOOL_STUDENT_TAFAQUH: "GET_SCHOOL_STUDENT_TAFAQUH",
  },
  studentBio: async () => {
    try {
      const request = await BaseService.request().get<StudentBioResponse>(
        "/school/student-bio",
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  studentBiography: async (nis: string) => {
    try {
      const request = await axios.get(
        `https://dehaotapi.sipond.id/api/siswa/data-siswa/${nis}`,
        {
          headers: {
            token: process.env.REACT_APP_TOKEN_HEADER,
          },
        },
      );
      return {
        success: request.data.status,
        message: request.data.message,
        data: request.data.data[0],
      };
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  updateStudentBiography: async (payload: FormBiography) => {
    try {
      const request = await axios.post(
        "https://dehaotapi.sipond.id/api/siswa/update-data-siswa",
        payload,
        {
          headers: {
            token: process.env.REACT_APP_TOKEN_HEADER,
          },
        },
      );
      return {
        success: request.data.status,
        message: request.data.message,
        data: request.data,
      };
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  studentHealth: async (payload: { nis: string; limit: string }) => {
    try {
      const request = await axios.get<StudentHealthResponse>(
        `https://dehaotapi.sipond.id/api/kesehatan/record`,
        {
          params: payload,
          headers: {
            token: process.env.REACT_APP_TOKEN_HEADER,
          },
        },
      );
      return {
        success: request.data.success,
        message: request.data.message,
        data: request.data.data,
      };
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  studentAbsences: async (limit: string) => {
    try {
      const request = await BaseService.request().get<StudentAbsencesResponse>(
        "/school/student-absences",
        { params: { limit } },
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  studentAchievement: async (payload: { nis: string; limit: string }) => {
    try {
      const request = await axios.get<StudentAchievementResponse>(
        `https://dehaotapi.sipond.id/api/siswa/achievement-record`,
        {
          params: payload,
          headers: {
            token: process.env.REACT_APP_TOKEN_HEADER,
          },
        },
      );
      return {
        success: request.data.success,
        message: request.data.message,
        data: request.data.data,
      };
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  studentViolations: async (payload: { nis: string; limit: string }) => {
    try {
      const request = await axios.get<StudentViolationsResponse>(
        `https://dehaotapi.sipond.id/api/siswa/violation-record`,
        {
          params: payload,
          headers: {
            token: process.env.REACT_APP_TOKEN_HEADER,
          },
        },
      );
      return {
        success: request.data.success,
        message: request.data.message,
        data: request.data.data,
      };
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  studentTahfidz: async (payload: { nis: string; limit: string }) => {
    try {
      const request = await axios.get<StudentTahfidzResponse>(
        `https://dehaotapi.sipond.id/api/siswa/tahfidz-record`,
        {
          params: payload,
          headers: {
            token: process.env.REACT_APP_TOKEN_HEADER,
          },
        },
      );
      return {
        success: request.data.success,
        message: request.data.message,
        data: request.data.data,
      };
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  studentTafaquh: async (payload: { nis: string; limit: string }) => {
    try {
      const request = await axios.get<StudentTafaquhResponse>(
        `https://dehaotapi.sipond.id/api/siswa/tafaquh-record`,
        {
          params: payload,
          headers: {
            token: process.env.REACT_APP_TOKEN_HEADER,
          },
        },
      );
      return {
        success: request.data.success,
        message: request.data.message,
        data: request.data.data,
      };
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  studentSuluk: async (payload: { nis: string }) => {
    try {
      const request = await axios.get<studentSulukResponse>(
        `https://dehaotapi.sipond.id/api/siswa/data-suluk`,
        {
          params: payload,
          headers: {
            token: process.env.REACT_APP_TOKEN_HEADER,
          },
        },
      );
      return {
        success: request.data.success,
        message: request.data.message,
        data: request.data.data,
      };
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  studentRapor: async (payload: { nis: string; semester: string }) => {
    try {
      const request = await axios.get<BaseResponse>(
        `https://dehaotapi.sipond.id/api/siswa/data-rapor`,
        {
          params: payload,
          headers: {
            token: process.env.REACT_APP_TOKEN_HEADER,
          },
        },
      );
      return {
        success: request.data.success,
        message: request.data.message,
        data: request.data.data,
      };
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  studentDailyScores: async (payload: { nis: string; semester: string }) => {
    try {
      const request = await axios.get<studentDailyScoresResponse>(
        `https://dehaotapi.sipond.id/api/siswa/daily-scores`,
        {
          params: payload,
          headers: {
            token: process.env.REACT_APP_TOKEN_HEADER,
          },
        },
      );
      return {
        success: request.data.success,
        message: request.data.message,
        data: request.data.data,
      };
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  studentFinalScores: async (payload: {
    nis: string;
    semester: string;
    type: string;
  }) => {
    try {
      const request = await axios.get<studentFinalScoresResponse>(
        `https://dehaotapi.sipond.id/api/siswa/final-exam-scores`,
        {
          params: payload,
          headers: {
            token: process.env.REACT_APP_TOKEN_HEADER,
          },
        },
      );
      return {
        success: request.data.success,
        message: request.data.message,
        data: request.data.data,
      };
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  checkPassword: async (
    payload: FormResetPassword,
  ): Promise<BaseResponseExternal> => {
    try {
      const request = await axios.post(
        "https://dehaotapi.sipond.id/api/siswa/check-password",
        payload,
        {
          headers: {
            token: process.env.REACT_APP_TOKEN_HEADER,
          },
        },
      );
      return {
        status: request.data.status,
        message: request.data.message,
        data: request.data,
      };
    } catch (error: any) {
      throw new Error(error.message);
    }
  },

  updatePassword: async (
    payload: FormUpdatePassword,
  ): Promise<BaseResponseExternal> => {
    try {
      const request = await axios.post(
        "https://dehaotapi.sipond.id/api/siswa/update-password",
        payload,
        {
          headers: {
            token: process.env.REACT_APP_TOKEN_HEADER,
          },
        },
      );
      return {
        status: request.data.status,
        message: request.data.message,
        data: request.data,
      };
    } catch (error: any) {
      throw new Error(error.message);
    }
  },
};
